import { HdChannelManifestationType } from '../../bodygraph/hd-channel-manifestation-type';

/**
 * Zachte card-achtergrondtinten per kanaaltype (spec
 * `2026-07-06-hd-moon-transit-chart-design.md` §6.3, beslissing §11.4).
 * Gedeeld door de card-laag en de legende zodat beide altijd synchroon lopen.
 */
export const HD_MOON_TRANSIT_TYPE_COLORS: Readonly<Record<HdChannelManifestationType, string>> = {
  projected: 'rgb(200,236,214)',
  generated: 'rgb(252,234,213)',
  manifested: 'rgb(240,180,175)',
};
